import { parseArray } from 'legacy/lut/components/widgets/public/onboarding/helpers/parsers'
import { IDropdownProps } from 'legacy/lut/library/dropdown'
import React, { useCallback, useMemo } from 'react'

import { IInputProps } from 'core-components/library/inputs'
import { IMultiselectProps } from 'core-components/library/multiSelect'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import {
  OnboardingDropdown,
  OnboardingInput,
  OnboardingMultiselect,
} from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { ICrudObject, IPartnerShipNA, IPartnerShipNaCrud } from './types'

interface IProps {
  onChange: (field: string) => (value: string) => void
  crud: IPartnerShipNaCrud
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const BusinessInformationNa = ({
  onChange,
  crud,
  item,
  writeAudience,
  disabled,
}: IProps) => {
  const primaryBusinessModel = useMemo(
    () => parseArray(item.PrimaryBusinessModel),
    [item.PrimaryBusinessModel]
  )

  const onChangeOwnershipStructure = useCallback(
    (value: string) => {
      if (value !== 'Other') {
        onChange('OwnershipStructureOther')('')
      }
      onChange('OwnershipStructure')(value)
    },
    [onChange]
  )

  return (
    <div>
      <div className={styles.text__title}>
        Business Information{' '}
        <div className={styles.text__rule}>{`(Applies to T1 & T2 Reseller)`}</div>
      </div>
      <VisualAudienceExtended<IDropdownProps>
        component={OnboardingDropdown}
        write={writeAudience}
        margin={'md'}
        label={'Ownership structure'}
        source={crud.OwnershipStructure}
        value={item.OwnershipStructure || ''}
        caption={'label'}
        onChange={onChangeOwnershipStructure}
        disabled={disabled}
      />
      <VisualAudienceExtended<IInputProps>
        component={OnboardingInput}
        write={writeAudience}
        margin={'md'}
        label={'“Ownership structure” -> Other'}
        value={item.OwnershipStructureOther || ''}
        onChange={onChange('OwnershipStructureOther')}
        disabled={disabled || item.OwnershipStructure !== 'Other'}
      />
      <VisualAudienceExtended<IMultiselectProps<ICrudObject>>
        component={OnboardingMultiselect}
        write={writeAudience}
        margin={'md'}
        label={'Primary Business Model'}
        source={crud.PrimaryBusinessModel}
        value={primaryBusinessModel}
        caption={'label'}
        onChange={(value) => onChange('PrimaryBusinessModel')(JSON.stringify(value))}
        disabled={disabled}
      />
    </div>
  )
}
